// extracted by mini-css-extract-plugin
module.exports = {"hand-container":"Hand_hand-container__1srQX","card-container":"Hand_card-container__PF0FR","title":"Hand_title__1Hy0g"};